import { createDownloadActions } from 'partner360/components/asyncContentWrapper/model'

import { REPORTS_NAMESPACE } from './constants'

export const {
  requestingStarted,
  downloadStarted,
  downloadProgress,
  downloadSucceeded,
  downloadFailed,
  processingStarted,
  downloadCancelled,
  resetDownload,
} = createDownloadActions(REPORTS_NAMESPACE)
